<!-- <div class="platform-announces-container">
    <h1 class="platform-announces-title">Editare anunț platformă</h1>
    <form class="platform-announces-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="platform-announces-field">
            <mat-form-field appearance="fill">
              <mat-label>Titlu</mat-label>
              <input type="text" matInput formControlName="title" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['title'].valid && form.controls['title'].touched">
              Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-announces-field">
            <mat-form-field appearance="fill">
              <mat-label>Conținut Anunț</mat-label>
              <input type="text" matInput formControlName="content" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['content'].valid && form.controls['content'].touched">
              Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-announces-field">
            <mat-form-field>
              <mat-label>Alege data de început</mat-label>
              <input matInput formControlName="date_start" [matDatepicker]="startPicker" />
              <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="!form.controls['date_start'].valid && form.controls['date_start'].touched">
              Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-announces-field">
            <mat-form-field>
              <mat-label>Alege data de sfârșit</mat-label>
              <input matInput formControlName="date_end" [matDatepicker]="endPicker" />
              <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
            <mat-error *ngIf="!form.controls['date_end'].valid && form.controls['date_end'].touched">
              Câmp obligatoriu
            </mat-error>
            <mat-error *ngIf="form.get('date_end')?.hasError('dateRangeError')">
                Data de sfârșit trebuie să fie mai mare decât data de început
            </mat-error>
        </div>
        <div class="platform-announces-field">
            <mat-form-field appearance="fill">
              <mat-label>Observații</mat-label>
              <input type="text" matInput formControlName="observations" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['observations'].valid && form.controls['observations'].touched">
              Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-announces-field">
            <div class="spinner">
              <mat-spinner color="primary" *ngIf="isSectionsLoading"></mat-spinner>
            </div>
            <mat-form-field *ngIf="!isSectionsLoading" appearance="fill">
              <mat-label>Permisiuni</mat-label>
              <mat-select formControlName="section_id">
                <mat-option *ngFor="let section of platformSections$ | async" [value]="section.id">
                  {{ section.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="!form.controls['section_id'].valid && form.controls['section_id'].touched">
                Câmp obligatoriu
              </mat-error>
            </mat-form-field>
        </div>

        <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
        <div class="platform-announces-action-btns">
            <button class="buttons" mat-flat-button type="button" (click)="closeDialog()">Close</button>
            <button class="buttons" mat-flat-button type="submit" color="primary">Save</button>
        </div>
    </form>
</div> -->
<h1>Update not implemented yet</h1>
<button class="buttons" mat-flat-button (click)="closeDialog()">Close</button>
